import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../../../../../../Components/Buttons/Button'
import ComponentLoader from '../../../../../../../../Components/Loading/ComponentLoader'
import Modal from '../../../../../../../../Components/Modal/Modal'
import Week from '../../../../../../../../Modules/ClassTimings/Components/Week'
import { H4, Text } from '../../../../../../../../Styles/typography'
import BatchTimingsStore from '../../Stores/BatchTimingsStore'
import Reschedule from './Components/Reschedule'
import { BatchTimingsEl } from './Elements'
import Notify from './Components/Notify'

function BatchTimings() {
  const [openNotify, showNotifyModal] = useState(false)
  const [open, showModal] = useState(false)
  const [rescheduleData, setRescheduleData] = useState(null)

  const {
    batchId,
    loading,
    loadFailed,
    batchTimings: { classes = {}, groupChatId } = {},
    userType,
    rescheduleClass,
    notifyEmail,
  } = BatchTimingsStore.useContainer()
  return (
    <BatchTimingsEl>
      <div className='header'>
        <H4>Batch Timings</H4>

        {!!batchId && (
          <div className='header-btns'>
            {userType === 'teacher' && (
              <Button
                name='Create Class'
                onClick={() => {
                  setRescheduleData({ extraClass: true })
                  showModal(true)
                }}
                type='primary'
              />
            )}
            {userType === 'teacher' && (
              <Button
                name='Notify Everyone'
                onClick={() => {
                  showNotifyModal(true)
                }}
                type='primary'
              />
            )}
            <Link to={`/dashboard/messages/${groupChatId}`}>
              <Button type='primary' onClick={() => {}} name={'Group Chat'} />
            </Link>
          </div>
        )}
      </div>

      <div className='batchTimings-content'>
        {!!batchId ? (
          <ComponentLoader loading={loading} loadFailed={loadFailed}>
            {Object.keys(classes).map((week, i) => (
              <Week
                key={`week-${i}`}
                index={i}
                data={classes[week]}
                weekIndex={week}
                initiateReschedule={(data) => {
                  setRescheduleData({ ...data, extraClass: false })
                  showModal(true)
                }}
                userType={userType}
                batchId={batchId}
              />
            ))}
          </ComponentLoader>
        ) : (
          <Text>Select a Batch</Text>
        )}
      </div>

      {openNotify && (
        <Modal close={() => showModal(false)}>
          <Notify
            onSubmit={async (message) => {
              await notifyEmail(message)
              showNotifyModal(false)
            }}
          />
        </Modal>
      )}

      {open && (
        <Modal close={() => showModal(false)}>
          <Reschedule
            data={rescheduleData}
            onSubmit={async (data) => {
              await rescheduleClass({ batchId, ...data })
              showModal(false)
            }}
          />
        </Modal>
      )}
    </BatchTimingsEl>
  )
}

export default BatchTimings
